<template>
   <div class="layout">
      <div class="container_layout">
         <div
            v-if="$vuetify.breakpoint.mdOnly || $vuetify.breakpoint.lgOnly || $vuetify.breakpoint.xlOnly"
            class="layout_logo"
         >
            <div v-if="settigRouteName !== 'terms-of-service' && settigRouteName !== 'privacy-policy'" class="box_logo">
               <router-link :to="{ name: 'advice' }">
                  <img src="../../assets/img/layoutLogo.svg" alt="" />
               </router-link>
            </div>
            <div
               v-if="settigRouteName !== 'terms-of-service' && settigRouteName !== 'privacy-policy'"
               class="title_logo"
            >
               <router-link :to="{ name: 'advice' }">
                  <p>Sleep Well Coach</p>
               </router-link>
            </div>
         </div>

         <div
            v-if="settigRouteName !== 'terms-of-service' && settigRouteName !== 'privacy-policy'"
            class="header_layout"
         >
            <!-- Mobail Advice version -->

            <div
               class="mobailAdviceVercion containerAdvice"
               v-if="'advice' === settigRouteName"
               :class="{ active: 'advice' === settigRouteName }"
            >
               <div class="mobailAdviceVersion">
                  <CategoryList />
               </div>
               <div id="mobileHiddenMenu"></div>
               <div id="mobileSearchBox"></div>
            </div>
            <div
               class="mobailAdviceVercion containerAdvice"
               v-if="'habits' === settigRouteName"
               :class="{ active: 'habits' === settigRouteName }"
            >
               <div id="mobileHiddenMenu"></div>
               <div id="mobileSearchBox"></div>
            </div>

            <!-- Mobail Advice version -->

            <!-- Modal Habits version -->

            <!-- Modal Habits version -->

            <div
               v-if="settigRouteName !== 'terms-of-service' && settigRouteName !== 'privacy-policy'"
               class="link__layout"
            >
               <div
                  v-if="
                     (!$vuetify.breakpoint.mdOnly && currentRouteName === 'menu') ||
                     (!$vuetify.breakpoint.sxOnly && currentRouteName === 'menu')
                  "
                  :class="{ showonmobile: currentRouteName === 'menu' }"
               >
                  <p>{{ "Hello, " + profile.first_name  || $t('Welcome.welcomeText') }}</p>
               </div>

               <div v-if="$vuetify.breakpoint.mdOnly && settigRouteName !== 'setting'" class="mobal__img">
                  <button class="mobal__img_box">
                     <img src="../../assets/img/text.svg" alt="" />
                  </button>
               </div>
               <div class="box__link">
                  <ul class="box__link">
                     <li
                        v-for="(item, index) in menu"
                        :key="index"
                        :class="{ active: settigRouteName ? item.nameLink === settigRouteName : false }"
                        class="advice__box"
                     >
                        <a :href="getUrl(item.nameLink)" class="routerLink">
                           <div class="advice__img">
                              <svg
                                 class="defaultColorSvg"
                                 :class="{ activeImg: settigRouteName === item.nameLink }"
                                 v-html="item.svg"
                              ></svg>
                           </div>
                           <div class="advices__link">{{ item.title }}</div>
                        </a>
                        <div
                           class="awakeningDiv"
                           v-if="item.nameLink === settigRouteName && item.nameLink === 'advice'"
                        >
                           <p class="paragrafAwakening">-</p>
                           <div class="awakeningImg" @click="openAwakening">
                              <CategoryList />
                           </div>
                        </div>
                     </li>
                  </ul>
               </div>
               <div
               class="headerRight"
               >
                  <div class="box__search">
                     <div class="search__layout" id="searchContainer"></div>
                  </div>

                  <router-link class="accountTopBtn" :to="{ name: 'account' }" title="Account" v-if="$route.name !== 'account'">
                     <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
                        <path d="M20 21c0-4-4-7-8-7s-8 3-8 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                     </svg>
                  </router-link>
               </div>

            </div>
            <!-- <HeaderList v-if="'advice' === settigRouteName || 'habits' === settigRouteName" /> -->
         </div>

         <div class="layout_content">
            <slot />
         </div>
         <Modal v-model="isOpenModal" :modalContentClasses="['modalStyleForEdite']">
            <RenameList v-if="activeForm === renameFormName" :formData="formData" @onCancel="isOpenModal = false" />
            <DeleteList
               v-else-if="activeForm === deleteFormList"
               :formData="formData"
               @onCancel="isOpenModal = false"
            />
            <NewList v-else-if="activeForm === createFormList" :formData="formData" @onCancel="isOpenModal = false" />
            <!-- <AddTipModal v-else-if="activeForm === saveToList" @onCancel="isOpenModal = false" /> -->
         </Modal>
         <!--  <Modal
            v-model="isEditMenuOpen"
            :wrapperContentClasses="['modalStyleForEditeWindow']"
            :modalContentClasses="['modalStyleForEdite']"
         >
            <div id="editMenu" @click="isEditMenuOpen = false"></div>
         </Modal> -->
      </div>
      <SWSnackBar class="shackBar" ref="snackbar" />
   </div>
</template>

<script>
window.addEventListener('load', function () {
   // Set a timeout...
   setTimeout(function () {
      // Hide the address bar!
      window.scrollTo(0, 1);
   }, 0);
});

const MENU = [
   {
      title: 'Advices',

      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" ><g clip-path="url(#clip0_2256_2209)"><path d="M3.5 14H4.66667M14 3.5V4.66667M23.3333 14H24.5M6.53333 6.53333L7.35 7.35M21.4667 6.53333L20.65 7.35"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.4993 18.668C9.5199 17.9334 8.7964 16.9092 8.43135 15.7406C8.0663 14.572 8.0782 13.3181 8.46536 12.1566C8.85253 10.9952 9.59532 9.98493 10.5885 9.26906C11.5818 8.55319 12.775 8.16797 13.9993 8.16797C15.2237 8.16797 16.4169 8.55319 17.4102 9.26906C18.4034 9.98493 19.1462 10.9952 19.5333 12.1566C19.9205 13.3181 19.9324 14.572 19.5673 15.7406C19.2023 16.9092 18.4788 17.9334 17.4993 18.668C17.0438 19.1189 16.7009 19.6707 16.4982 20.2787C16.2955 20.8867 16.2388 21.5339 16.3327 22.168C16.3327 22.7868 16.0868 23.3803 15.6493 23.8179C15.2117 24.2555 14.6182 24.5013 13.9993 24.5013C13.3805 24.5013 12.787 24.2555 12.3494 23.8179C11.9118 23.3803 11.666 22.7868 11.666 22.168C11.7599 21.5339 11.7032 20.8867 11.5005 20.2787C11.2978 19.6707 10.9549 19.1189 10.4993 18.668"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.3164 19.832H16.6831"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_2256_2209"><rect width="28" height="28" fill="white"/></clipPath></defs></svg>',
      nameLink: 'advice',
   },
   {
      title: 'Habits',
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" ><path d="M11.1673 1.5V9.66667H18.1673L8.83398 22.5V14.3333H1.83398L11.1673 1.5Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      nameLink: 'habits',
   },
   {
      title: 'Settings',
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" ><g clip-path="url(#clip0_2256_3908)"><path d="M12.0458 5.0365C12.5428 2.98783 15.4572 2.98783 15.9542 5.0365C16.0287 5.34427 16.1749 5.63008 16.3808 5.87067C16.5867 6.11126 16.8465 6.29983 17.1391 6.42104C17.4317 6.54224 17.7487 6.59266 18.0644 6.56818C18.3801 6.5437 18.6856 6.44502 18.956 6.28017C20.7562 5.1835 22.8177 7.24383 21.721 9.04517C21.5564 9.31543 21.4579 9.62073 21.4334 9.93624C21.409 10.2517 21.4594 10.5686 21.5804 10.8609C21.7015 11.1533 21.8899 11.413 22.1302 11.6189C22.3705 11.8248 22.656 11.9711 22.9635 12.0458C25.0122 12.5428 25.0122 15.4572 22.9635 15.9542C22.6557 16.0287 22.3699 16.1749 22.1293 16.3808C21.8887 16.5867 21.7002 16.8465 21.579 17.1391C21.4578 17.4317 21.4073 17.7487 21.4318 18.0644C21.4563 18.3801 21.555 18.6856 21.7198 18.956C22.8165 20.7562 20.7562 22.8177 18.9548 21.721C18.6846 21.5564 18.3793 21.4579 18.0638 21.4334C17.7483 21.409 17.4314 21.4594 17.1391 21.5804C16.8467 21.7015 16.587 21.8899 16.3811 22.1302C16.1752 22.3705 16.0289 22.656 15.9542 22.9635C15.4572 25.0122 12.5428 25.0122 12.0458 22.9635C11.9713 22.6557 11.8251 22.3699 11.6192 22.1293C11.4133 21.8887 11.1535 21.7002 10.8609 21.579C10.5683 21.4578 10.2513 21.4073 9.93558 21.4318C9.61986 21.4563 9.31438 21.555 9.044 21.7198C7.24383 22.8165 5.18233 20.7562 6.279 18.9548C6.44362 18.6846 6.54214 18.3793 6.56656 18.0638C6.59099 17.7483 6.54062 17.4314 6.41955 17.1391C6.29848 16.8467 6.11014 16.587 5.86982 16.3811C5.6295 16.1752 5.34399 16.0289 5.0365 15.9542C2.98783 15.4572 2.98783 12.5428 5.0365 12.0458C5.34427 11.9713 5.63008 11.8251 5.87067 11.6192C6.11126 11.4133 6.29983 11.1535 6.42104 10.8609C6.54224 10.5683 6.59266 10.2513 6.56818 9.93558C6.5437 9.61986 6.44502 9.31438 6.28017 9.044C5.1835 7.24383 7.24383 5.18233 9.04517 6.279C10.2118 6.98833 11.7238 6.36067 12.0458 5.0365Z"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path class="current-path" d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/</g><defs<clipPath id="clip0_2256_3908"><rect width="28" height="28" fill="#ffffff"/></clipPath></defs></svg>',
      nameLink: 'setting',
   },
];

import { SWSnackBar } from 'sw-ui-kit';
import { KEY_THEME, KEY_FONT_SIZE, DEFAULT_SIZE, SIZES } from '../../store/themeModes';
import CategoryList from '../../views/AdvicesApp/SettingMenu/CategoryList.vue';
import RenameList from '../../views/AdvicesApp/SettingMenu/RenameList.vue';
import Modal from '../UI/Modal.vue';
import NewList from '../../views/AdvicesApp/SettingMenu/NewList.vue';
import DeleteList from '../../views/AdvicesApp/SettingMenu/DeleteList.vue';
import mutations from '../../store/mutation-types';
import actions from '../../store/action-types';

// import AddTipModal from '../../views/AdvicesApp/AddTipModal.vue';

export const FORM_RENAME = 'rename';
export const FORM_DELETE = 'delete';
export const FORM_CREATE_LIST = 'createList';

// export const FORM_SAVE_TO_LIST = 'saveToList';

export default {
   provide() {
      return {
         openModal: this.openModal,
         isOpenModal: this.isOpenModal,
         snackBar: this.showMessage,
         isEditMenuOpen: this.isEditMenuOpen,
      };
   },

   data() {
      return {
         activeIndex: null,
         search: '',
         isDarkTheme: false,
         imgAwakening: true,
         areOptionVisibelCategoryDrop: false,
         showInputAdviceMobail: true,
         activeForm: null,
         isOpenModal: false,
         isEditMenuOpen: false,
         hideSearchInput: true,
         fontSize: 'default',
         formdata: null,
      };
   },

   components: {
      CategoryList,
      RenameList,
      Modal,
      NewList,
      DeleteList,
      SWSnackBar,
      // AddTipModal,
   },
   mounted() {
      this.$store.dispatch(`profile/${actions.FETCH}`);
      
      try {
         this.isDarkTheme = JSON.parse(localStorage.getItem(KEY_THEME));
      } catch {
         this.isDarkTheme = false;
      }
      try {
         const res = JSON.parse(localStorage.getItem(KEY_FONT_SIZE));
         if (SIZES.includes(res)) this.fontSize = JSON.parse(localStorage.getItem(KEY_FONT_SIZE));
      } catch {
         this.fontSize = DEFAULT_SIZE;
      }

      // document.addEventListener('click', this.closeInput);
   },
   // beforeDestroy() {
   //    document.removeEventListener('click', this.closeInput);
   // },

   methods: {
      // closeInput(event) {
      //    const clickedElement = event.target;
      //    const inputElement = this.$refs.search;

      //    if (!inputElement.contains(clickedElement)) {
      //       this.showInputAdviceMobail = false;
      //    }
      // },
      showMessage(message) {
         this.$refs.snackbar.showSnackbar(message, 2000);
      },
      openModal(formName, formData) {
         this.isOpenModal = true;
         this.activeForm = formName;
         this.formData = formData;
      },
      hideInput() {
         this.hideSearchInput = false;
      },
      getUrl(nameLink) {
         console.log(`${process.env.VUE_APP_URL}/${nameLink}`);
         if (nameLink === 'advice') {
            return `${process.env.VUE_APP_URL}/`;
         }
         return `${process.env.VUE_APP_URL}/${nameLink}`;
      },

      showInput() {
         if (!this.showInputAdviceMobail) {
            return (this.showInputAdviceMobail = true);
         } else {
            return this.showInputAdviceMobail;
         }
      },
      changeThemeMode(isDarkMode) {
         if (typeof isDarkMode !== 'boolean') return;
         this.isDarkTheme = isDarkMode;
      },
      changeFontSizeStyle(fontSize) {
         if (!SIZES.includes(fontSize)) return;

         this.fontSize = fontSize;
      },
      openAwakening() {
         this.imgAwakening = !this.imgAwakening;
      },
      showInputAdviceMobil() {
         this.showInputAdviceMobail = !this.showInputAdviceMobail;
      },

      openEditMenu() {
         this.isEditMenuOpen = !this.isEditMenuOpen;
      },

      onSerchBlur() {
         if (!this.search.length) {
            this.showInputAdviceMobail = true;
         }
      },
   },

   computed: {
      menu() {
         return MENU;
      },
      settigRouteName() {
         return this.$route?.matched?.[1]?.name;
      },

      renameFormName() {
         return FORM_RENAME;
      },
      deleteFormList() {
         return FORM_DELETE;
      },
      createFormList() {
         return FORM_CREATE_LIST;
      },
      currentRouteName() {
         return this.$route.name;
      },
      firstCategory() {
         return this.$store.getters['advice/getCategoriesList'].at(0);
      },
      profile() {
         return this.$store.getters['profile/getProfile'];
      },
      // saveToList() {
      //    return FORM_SAVE_TO_LIST;
      // },
   },
   watch: {
      $route(to, from) {
         this.search = '';
         if (to.name === 'habits') {
            this.$store.commit(`advice/${mutations.UPDATE_SELECTED_CATEGORY}`, 'Habits');
         } else if (from.name === 'habits') {
            this.$store.commit(`advice/${mutations.UPDATE_SELECTED_CATEGORY}`, this.firstCategory?.code);
         }
      },
      isEditMenuOpen() {
         this.$store.commit('advice/updateIsEditMenuOpen', this.isEditMenuOpen);
      },
      // showInputAdviceMobail() {
      // 	if (!this.showInputAdviceMobail) this.$nextTick(() => this.$refs.search?.$el.querySelector('input')?.focus());
      // },
      search() {
         this.$store.commit(`advice/${mutations.UPDATE_SEARCH}`, this.search);
      },
   },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;800&display=swap');
.shackBar .snackbar {
   bottom: 10% !important;
   z-index: 10000 !important;
}
.layout {
   background-color: var(--surface);
   color: var(--font-color-black);
   height: 100%;
}
.awakeningDiv {
   display: flex;
}
.habitsInput {
   width: 299px;
}
.awakeningImg img {
   width: 14px;
   height: 14px;
   margin-left: 5px;
   display: block;
}
.mobailAdvaciListImg {
   width: 32px;
   height: 32px;
   cursor: pointer;
}
.mobailAdvaciListImg svg {
   stroke: var(--stroke-color);
}
.lupaBtn svg {
   stroke: var(--stroke-color);
}
.activeOpenMenu svg {
   stroke: #105ebc;
}

.mobailAdvaciListImg {
   margin-right: 20px;
}
.imgRedact {
   margin-right: 40px;
}
.mobailAdviceVercion {
   display: none;
}
.containerAdvice {
   display: none;
   position: absolute;
   left: 0;
   top: 0;
   height: 64px;
   width: 100%;
   align-items: center;
   justify-content: space-between;
   padding: 15px 16px;
   background-color: var(--bg-install-element);
}
.containerHabits {
   display: none;
   position: absolute;
   left: 0;
   top: 0;
   width: 100%;
   align-items: center;
   justify-content: space-around;
   padding: 15px 16px;
   background-color: var(--bg-install-element);
}
.box_imgMobailAdvice {
   display: flex;
}
.box_imgMobailAdviceimgRedact {
   display: flex;
   width: 100%;
   justify-content: space-between;
}

.paragrafAwakening {
   /* padding-right: 10px; */
   padding-left: 10px;
   padding-top: 10px;
}

.showonmobile {
   display: none;
}
.currentAcountPage {
   display: none;
}

@media screen and (max-width: 800px) {
   .paragrafAwakening {
      display: none;
   }
   .containerAdvice {
      display: flex;
   }
   .containerHabits {
      display: flex;
   }
}

.awakeningImg {
   display: flex;
}

.container_layout {
   max-width: 1360px;
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 0px 20px;
   margin: 0 auto;

   margin-bottom: 20px;
   overflow-y: auto;
}
.layout_content {
   flex: 1 0 auto;
   /* height: 70svh;  */
   padding-bottom: 10px;
   /* overflow: auto;  */
}
::-webkit-scrollbar {
   width: 8px;
   background-color: transparent;
}

::-webkit-scrollbar-thumb {
   background-color: rgba(255, 255, 255, 0);
   border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
   background-color: rgba(255, 255, 255, 0);
}
.layout_logo {
   display: flex;
   padding-top: 20px;
   justify-content: start;
   align-items: center;
}
.box_logo {
   width: 40px;
   height: 40px;
   margin-right: 16px;
}
.title_logo {
   font-size: 24px;
   line-height: 32px;
   font-weight: 700;
   font-family: 'Baloo 2';
   color: #1073eb;
}
.title_logo p {
   cursor: pointer;
}
.header_layout {
   max-width: 876px;
   width: 100%;
   margin: 0 auto;
}
.advice__img {
   margin-right: 13px;
   width: 28px;
   height: 28px;
}
.advice__box {
   display: flex;
   font-size: 16px;
   font-weight: 400;
   align-items: center;
   margin-right: 47px;
}
.routerLink {
   display: flex;
   align-items: center;
}
.defaultColorSvg {
   transition: all 0.3s ease;
   stroke: var(--default-color-svg);
   fill: var(--color-img-blackTime-fill);
}
.advice__img svg {
   width: 100%;
   height: 30px;
}

.active {
   color: #1073eb;
}
.activeImg {
   fill: #1073eb;
   stroke: #1073eb;
}
.activeImg .current-path {
   fill: var(--color-img-blackTime-layout-fill);
   stroke: #1073eb;
}

.link__layout {
   display: flex;
   margin-top: 30px;
   color: var(--header--layout);
   /* flex-wrap: wrap; */
   justify-content: space-between;
}

.headerRight {
  display: flex;
  align-items: center;
  gap: 16px;
}

.accountTopBtn {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: all 0.3s ease;
  border: 1px solid rgba(255,255,255, 0.08);
  border-radius: 50%;
}

.accountTopBtn svg {
  stroke: #105ebc;
}

.accountTopBtn:hover {
  background: rgba(255,255,255);
}

.mobal__img {
   display: none;
}
.box__link {
   display: flex;
   position: relative;
}
.showonmobile {
   text-align: center;
   padding-top: 80px;
   padding-bottom: 20px;
   margin: 0 auto;
   font-size: 24px;
   font-weight: 700;
   line-height: 31, 2px;
}
.mobailAdviceVersion {
   display: none;
}
.imgRedact svg {
   stroke: var(--stroke-color);
}
@media (max-width: 959px) {
  .headerRight .box__search {
    display: none;
  }
}
@media screen and (max-width: 804px) {
   .box__link {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 64px;
      z-index: 200;
      background-color: var(--color-img-blackTime-layout-fill);
   }
   .mobailAdviceVersion {
      display: block;
   }
   .layout_content {
      /* position: relative; */
      padding-bottom: 60px;
   }
   .awakeningImg {
      display: none;
   }

   .box__link {
      align-items: center;
      justify-content: center;
   }
   .routerLink {
      flex-direction: column;
      padding: 0px 70px;
   }
   .advice__box {
      margin-right: 0px;
      padding-top: 15px;
      padding-bottom: 15px;
   }

   .mobal__img {
      display: block;
   }
   .advice__img {
      margin-right: 0px;
      align-items: center;
      justify-content: center;
   }
   .box__link {
      border-top: 1px solid #a8a7a7;
   }
}

@media screen and (max-width: 600px) {
   .routerLink {
      padding: 0px 50px;
   }
   .showonmobile {
      display: block;
   }
   .link__layout {
      margin-top: 50px;
   }
   .profile {
      padding-top: 80px;
   }
   .routerLink {
      padding: 0px 50px;
   }
   .modalStyleForEdite {
      transform: translateY(unset);
      max-width: 358px !important;
      padding: 25px 0px 25px 0px !important;
      z-index: 300 !important;
   }
   /* .modal__content {
      transform: translateY(-57px);
   } */
}

@media screen and (max-width: 420px) {
   .routerLink {
      padding: 0px 25px;
   }
   .shackBar .snackbar {
      left: 50% !important;
   }
   .modalStyleForEditeWindow {
      vertical-align: top !important;
      transform: translateY(27px) !important;
   }
}

#mobileSearchBox {
   margin-left: 3px;
}
</style>
